<template>
  <div class="booking-room">
    <div class="main-invoice-group">
      <div class="picture-container" :style="`background-image: url(${picture})`"></div>
      <div class="room-details">
        <div class="line1">{{ roomName }}</div>
        <div class="dates" v-html="$t('step4-multi.booking-room.dates', start.format('DD MMMM YYYY'), end.format('DD MMMM YYYY'))">
        </div>
        <div class="price-container">
          <span class="list-badge" v-if="bookingRoom.nb_guests > 1">{{ bookingRoom.nb_guests }} {{ $t('step4-multi.booking-room.travelers.plural')}}</span>
          <span class="list-badge" v-else>{{ bookingRoom.nb_guests }} {{ $t('step4-multi.booking-room.travelers.singular')}}</span>
          <span class="list-badge">{{ priceName }}</span>
          <span class="list-badge list-badge-option" v-for="option in options" :key="option.id">{{ template(option.text.checkbox, {$nbGuest: nbGuest, $plural: nbGuest > 1, $singular: nbGuest <= 1}) }}</span>
        </div>
      </div>
      <div class="invoice-action">
        <button class="v1-invoice-button" @click="handleClickOnEdit" v-if="useActions && !lock && useUpdate">
          {{ $t('step4-multi.cta.update' )}}
        </button>
        <button class="v1-invoice-button" @click="handleClickOnDelete" v-if="useActions && !lock ">
          {{ $t('step4-multi.cta.delete' )}}
        </button>
      </div>
    </div>
    <div class="extra-values" v-if="bookingRoom.extras.length > 0">
      <step4-extra :extra="extra" v-for="extra in bookingRoom.extras" :key="extra.id"></step4-extra>
    </div>
  </div>
</template>

<script>
import {templateParser} from '../../../plugins/template.plugin';

import Step4Extra from "./step4-extra";
export default {
  name: "step4-booking-room",
  components: {Step4Extra},
  props: {
    bookingRoom: {
      required: true,
    },
    lock: {
      required: true,
    },
    roomPrice: {
      required: true,
    },
    start: {
      required: true,
    },
    end: {
      required: true,
    },
    options: {
      required: true,
    },
    useActions: {
      required: true,
    },
    useUpdate: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    picture() {
      return this.bookingRoom.room.main_picture.absolute_path + '?w=500&h=500&crop-to-fit';
    },
    roomName() {
      return this.bookingRoom.room.text.short_name;
    },
    priceName() {
      return this.roomPrice.text.title;
    },
    nbGuest() {
      return this.bookingRoom.nb_guests;
    }
  },
  methods: {
    template: templateParser,
    async handleClickOnEdit() {
      await this.$router.push({
        name: 'step3', params: {
          shoppingCart: this.$store.state.shoppingCart.uuid,
          shoppingBookingId: this.bookingRoom.id
        }
      })
    },
    async handleClickOnDelete() {
      const ok = confirm('Voulez-vous vraiment supprimer cette réservation ?');
      if (!ok) return;
      await this.$store.dispatch('shoppingCart/booking/bookingRoom/delete', {id: this.bookingRoom.id});
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step4-multi/step4-booking-room.vue